<template>
  <el-switch @change="change" v-model="value"></el-switch>
</template>

<script>
export default {
  data() {
    return {
      value: false
    }
  },
  beforeMount() {
    this.value = (this.params.data[this.params.props.fieldName] === 1)
  },
  methods: {
    change(val) {
      this.params.props.saveAction(this.params, (val)? 1 : 0, () => {}, this.params.props.fieldName)
    }
  }
}
</script>
